import InputV2 from "../../../material/input/InputV2";
import PasswordInput from "../../../material/passwordInput/PasswordInput";
import * as regex from "../../../../service/regex";

const Account = ({ account, onInputChange }) => {
  return (
    <div className="w-full gap-[10px] rounded-[6px] border-[#E2E2E4] border p-[9px_16px] mb-[10px]">
      <h1 className="text-[18px] mb-[10px]">ตั้งค่าบัญชีผู้ใช้</h1>

      {/* <div className="flex flex-row gap-[16px] md:flex-col w-full mb-[16px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          ชื่อผู้ใช้งาน
          <InputV2
            type="text"
            placeholder="ชื่อผู้ใช้งาน (ตัวอักษรภาษาอังกฤษ สัญลักษณ์ หรือตัวเลขเท่านั้น ห้ามเว้นวรรค)"
            value={account.username}
            onChangeEvt={(value) => onInputChange("username", value)}
          />
        </div>
      </div> */}
      <div className="flex justify-center items-center flex-col gap-[16px] first-line:w-full mb-[16px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          <PasswordInput
            regex={regex.password()}
            placeholder="รหัสผ่าน"
            label="รหัสผ่าน"
            value={account.password}
            setValue={(value) => onInputChange("password", value)}
          ></PasswordInput>
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          <PasswordInput
            regex={regex.password()}
            placeholder="ยืนยันรหัสผ่าน"
            label="ยืนยันรหัสผ่าน"
            value={account.confirm_password}
            setValue={(value) => onInputChange("confirm_password", value)}
          ></PasswordInput>
        </div>
      </div>
    </div>
  );
};
export default Account;
